import routes from "../constants/routes";
import { lazyLoadRoutes } from "../utils/lazy-loader";

export const SalaryRoutes = [
  {
    path: routes.salary.salaryProcess,
    element: lazyLoadRoutes("salary/SalaryProcess/pages/salary-process"),
  },
  {
    path: routes.salary.processList,
    element: lazyLoadRoutes("salary/SalaryProcess/pages/process-list"),
  },
  {
    path: routes.salary.list,
    element: lazyLoadRoutes("salary/SalaryProcessed/list"),
  },
  {
    path: `${routes.salary.processedList}/:id`,
    element: lazyLoadRoutes("salary/SalaryProcessed/processedList"),
  },
  {
    path: `${routes.salary.processedView}/:id`,
    element: lazyLoadRoutes("salary/SalaryProcessed/processedView"),
  },
  {
    path: routes.salary.salarySheetList,
    element: lazyLoadRoutes("salary/SalarySheet/pages/salarySheetList"),
  },
  {
    path: routes.salary.salarySheetSetting,
    element: lazyLoadRoutes("salary/SalarySheet/pages/salarySheetSettingList"),
  },
  {
    path: routes.salary.salarySheetSettingAdd,
    element: lazyLoadRoutes("salary/SalarySheet/pages/salarySheetSettingAdd"),
  },
  {
    path: `${routes.salary.salarySheetSettingEdit}/:id`,
    element: lazyLoadRoutes("salary/SalarySheet/pages/salarySheetSettingEdit"),
  },
  {
    path: `${routes.salary.salarySheetSettingReport}`,
    element: lazyLoadRoutes("salary/SalarySheet/pages/salarySheetReport"),
  },
];
